import {Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy} from "@angular/core";
@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {

  private timer: number;
	constructor(private changeDetectorRef: ChangeDetectorRef, private ngZone: NgZone) {}
	transform(value:string) {
		this.removeTimer();
		let d = new Date(value);
		let now = new Date();
		// let seconds = Math.round(Math.abs((now.getTime() - d.getTime())/1000));
		let seconds = Math.floor((now.getTime() - (d.getTime()))/1000);
		let timeToUpdate = (Number.isNaN(seconds)) ? 1000 : this.getSecondsUntilUpdate(seconds) *1000;
		this.timer = this.ngZone.runOutsideAngular(() => {
			if (typeof window !== 'undefined') {
				return window.setTimeout(() => {
					this.ngZone.run(() => this.changeDetectorRef.markForCheck());
				}, timeToUpdate);
			}
			return 0;
		});
		let minutes = Math.floor(seconds/60);
        let hours = Math.floor(minutes/60);
        let days = Math.floor(hours/24);
		// let minutes = Math.round(Math.abs(seconds / 60));
		// let hours = Math.round(Math.abs(minutes / 60));
		// let days = Math.round(Math.abs(hours / 24));
		// let months = Math.round(Math.abs(days/30.416));
		// let years = Math.round(Math.abs(days/365));
		let calhours = hours-(days*24);
       let  calminutes = minutes-(days*24*60)-(calhours*60);	
		if (Number.isNaN(seconds)){
			return '';
		} else if (seconds <= 45) {
			return 'a few seconds ago';
		} else if (seconds <= 90) {
			return '1 minute ago';
		} else if (minutes <= 59) {
			return minutes + ' minutes ago';
		} else if (minutes >= 60 && hours<24) {
			// return `${hours}${hours>1 ?` hrs `:` hr `}${calminutes}${calminutes> 1?` mins`:` min`} ago`;
			return `${hours}${hours>1 ?` hrs `:` hr `} ago`;
		} 
		 else if (hours >= 24 && hours <165) {
			// return `${days}${days>1?' days ':' day '}${calhours}${hours>1 ?` hrs `:` hr `}${calminutes}${calminutes> 1?` mins`:` min`} ago`;
			return `${days}${days>1?' days':' day'} ago`;
		} 
		else if (days <= 7) {
			return days + ' days ago';
		}
		else if (days < 6 && days <= 7) {
			return  '1 week ago';
		}
		else if (days > 7 && days <= 14) {
			return  '2 weeks ago';
		}
		else if (days > 14 && days <= 21) {
			return  '3 weeks ago';
		}
		else if (days > 21 && days <= 28) {
			return  '4 weeks ago';
		}
	 
		/* else if (hours <= 168) {
			return hours + ' hours ago';
		}
		else if (days <= 45) {
			return 'a month ago';
		} else if (days <= 345) {
			return months + ' months ago';
		} else if (days <= 545) {
			return 'a year ago';
		} else { // (days > 545)
			return years + ' years ago';
		}*/
		else{
			const monthName = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
			var month = monthName[d.getMonth()]; //months from 1-12
			var day = d.getDate();
			var year = d.getFullYear();
			return `${day} ${month} ${year}`;
			;
		}
	}
	ngOnDestroy(): void {
		this.removeTimer();
	}
	private removeTimer() {
		if (this.timer) {
			window.clearTimeout(this.timer);
			this.timer = 0;
		}
	}
	private getSecondsUntilUpdate(seconds:number) {
		let min = 60;
		let hr = min * 60;
		let day = hr * 24;
		if (seconds < min) { // less than 1 min, update every 2 secs
			return 2;
		} else if (seconds < hr) { // less than an hour, update every 30 secs
			return 30;
		} else if (seconds < day) { // less then a day, update every 5 mins
			return 300;
		} else { // update every hour
			return 3600;
		}
	}
}
